import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TableFooter,
  TableSortLabel,
} from "@mui/material";
import { styled } from "@mui/system";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { React, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTableDataForCustomer } from "../analyzeUtils";
import { setState } from "../analyzeSlice";
import CollapseSection from "../../../components/ui/CollapseSection";
import SeeDetailModal from "./SeeDetailModal";

export default function ModificationDataTable() {
  const state = useSelector((store) => store.analyze);
  const dispatch = useDispatch();
  const { modificationsTD, duration, modificationsData } = state;
  let { lstAnalyzePopupChartData } = modificationsData;
  
  const { rows, columns } = getTableDataForCustomer(modificationsTD, duration);
  const [tableRows, setTableRows] = useState(rows);

  const [searchText, setSearchText] = useState("");
  const [isModifiedSelected, setIsModifiedSelected] = useState("");

  const headers = columns.map((option) => option.field);

  const [selected, setSelected] = useState(
    rows?.map((data) => data.customerName)
  );

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [orderBy, setOrderBy] = useState("customerName");
  const [order, setOrder] = useState("asc");

  // const handleSort = (column) => {
  //   const isAsc = orderBy === column && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(column);
  

  //  const sortedData=[...tableRows].sort((a, b) => {
  //   const aValue = isNaN(a[column].replace(/,/g,"")) ? a[column].replace(/,/g,"") : Number(a[column].replace(/,/g,""));
  //   const bValue = isNaN(b[column].replace(/,/g,"")) ? b[column].replace(/,/g,"") : Number(b[column].replace(/,/g,""));

  //   if (aValue < bValue) return isAsc ? -1 : 1;
  //   if (aValue > bValue) return isAsc ? 1 : -1;

  //   return 0;
  // }); 

  


//   setTableRows(sortedData);
// };

const handleSort = (column) => {
  const isAsc = orderBy === column && order === "asc";
  setOrder(isAsc ? "desc" : "asc");
  setOrderBy(column);

  const sortedData = [...tableRows].sort((a, b) => {
    const aValue = a[column] === "" ? null : isNaN(a[column].replace(/,/g, "")) ? a[column].replace(/,/g, "") : Number(a[column].replace(/,/g, ""));
    const bValue = b[column] === "" ? null : isNaN(b[column].replace(/,/g, "")) ? b[column].replace(/,/g, "") : Number(b[column].replace(/,/g, ""));

    if (aValue === null) return 1; // a is empty, place it last
    if (bValue === null) return -1; // b is empty, place it last

    if (aValue < bValue) return isAsc ? -1 : 1;
    if (aValue > bValue) return isAsc ? 1 : -1;

    return 0;
  });

  setTableRows(sortedData);
};

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };



  useEffect(() => {
    let filteredRows = rows;
   // let filteredRows=tableRows;

    // if (searchText !== "") {
    //   const searchLowercase = searchText.toLowerCase();
    //   filteredRows = filteredRows.filter((row) => {
    //     return row.customerName.toLowerCase().includes(searchLowercase);
    //   });
    // }

    let filteredIds = lstAnalyzePopupChartData;
    //let filteredRows = rows;
    if (isModifiedSelected == "Modified") {
      filteredIds = filteredIds.filter(
        (x) => x.increase != 0 || x.decrease != 0
      ).map(i => i.customerId);
      filteredRows = filteredRows.filter(
        (x) => filteredIds.includes(x.id)
      );
    }

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return row.customerName.toLowerCase().includes(searchLowercase);
      });
    }


    setTableRows(filteredRows);
  }, [searchText]);

  useEffect(() => {
    let filteredIds = lstAnalyzePopupChartData;
    let filteredRows = rows;
    if (isModifiedSelected == "Modified") {
      filteredIds = filteredIds.filter(
        (x) => x.increase != 0 || x.decrease != 0
      ).map(i => i.customerId);
      filteredRows = filteredRows.filter(
        (x) => filteredIds.includes(x.id)
      );
    }

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return row.customerName.toLowerCase().includes(searchLowercase);
      });
    }    

    setTableRows(filteredRows);
  }, [isModifiedSelected]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.customerName);
      setSelected(newSelecteds);
      dispatch(setState("selectedDataPointsForModification", newSelecteds));
      return;
    }

    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
    dispatch(setState("selectedDataPointsForModification", newSelected));
  };

  return (
    <CollapseSection title="Customer Details">
      <Box sx={{ mt: 3 }}>
        <Grid container columns={5} spacing={3}>
          <Grid item sm={1}>
            <FormControl>
              <InputLabel></InputLabel>
              <Select
                value={isModifiedSelected ? isModifiedSelected : "All"}
                label=""
                sx={{
                  height: 200,
                  width: 35,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={(e) => setIsModifiedSelected(e.target.value)}
              >
                <MenuItem key={1} value={"All"}>
                  {"All"}
                </MenuItem>
                <MenuItem key={2} value={"Modified"}>
                  {"Modified"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={2}>
            <TextField
              variant="outlined"
              label="Filter.."
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
        </Grid>
      </Box>
      <br />
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650, backgroundColor: "white" }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < rows.length
                  }
                  checked={rows.length > 0 && selected.length === rows.length}
                  onChange={handleSelectAllClick}
                  inputProps={{
                    "aria-label": "select all items",
                  }}
                  sx={{ color: "#005587 !important" }}
                />
              </TableCell>
              {columns.map((column, index) => (
                <TableCell key={column.field}  align = {index > 0? "center": "left"}>
                  {/* {column.headerName} */}
                  <TableSortLabel 
                  active={orderBy === column.field}
                  direction={orderBy === column.field ? order : 'asc'}
                  onClick={() => handleSort(column.field)}
                  >{column.headerName}</TableSortLabel>
                
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: "white !important" }}>
            {(rowsPerPage > 0
              ? tableRows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableRows
            ).map((row) => {
              const isItemSelected = isSelected(row.customerName);
              return (
                <TableRow
                  sx={{ backgroundColor: "white !important" }}
                  key={row.id}
                  role="checkbox"
                  onClick={(event) => handleClick(event, row.customerName)}
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  selected={isItemSelected}
                >
                  <TableCell sx={{ backgroundColor: "white !important" }}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>
                  {headers.map(
                    (header, index) =>
                      header !== "details" && (
                        <TableCell
                          align = {index > 0? "center": "left"}
                          sx={{ backgroundColor: "white !important" }}
                        >
                          {row[header]}
                        </TableCell>
                      )
                  )}
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: "white !important" }}
                  >
                    <SeeDetailModal
                      rows={rows}
                      selectedID={row.id}
                      customerName={row.customerName}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <tr style={{ height: 34 * emptyRows }}>
                <td colSpan={3} aria-hidden />
              </tr>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <CustomTablePagination
                rowsPerPageOptions={[20, 50, 100]}
                colSpan={headers.length + 1}
                count={tableRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    // showFirstButton: true,
                    // showLastButton: true,
                    slots: {
                      // firstPageIcon: FirstPageRoundedIcon,
                      // lastPageIcon: LastPageRoundedIcon,
                      nextPageIcon: ChevronRightRoundedIcon,
                      backPageIcon: ChevronLeftRoundedIcon,
                    },
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </CollapseSection>
  );
}

const blue = {
  50: "#F0F7FF",
  200: "#A5D8FF",
  400: "#3399FF",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${classes.spacer} {
    display: none;
  }

  & .${classes.toolbar}  {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 4px 0;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.select}{
    padding: 2px 0 2px 4px;
    border: none;
    background-color: transparent;
    
    transition: all 100ms ease;
    cursor: pointer;

    &:hover {
      background-color: none;
      border-color:none;
    }

    &:focus {
      outline: none;
      border-color: none;
    }
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.actions} {
    display: flex;
    gap: 6px;
    border: transparent;
    text-align: center;
  }

  & .${classes.actions} > button {
    display: flex;
    align-items: center;
    padding: 0;
    border: transparent;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    transition: all 120ms ease;

    > svg {
      font-size: 22px;
    }

    &:hover {
      background-color: ${theme.palette.mode === "dark" ? grey[800] : grey[50]};
      border-color: ${theme.palette.mode === "dark" ? grey[600] : grey[300]};
    }

    &:focus {
      outline: 3px solid ${
        theme.palette.mode === "dark" ? blue[400] : blue[200]
      };
      border-color: ${blue[400]};
    }

    &:disabled {
      opacity: 0.3;
      &:hover {
        border: 1px solid ${
          theme.palette.mode === "dark" ? grey[800] : grey[200]
        };
        background-color: transparent;
      }
    }
  }
  `
);
